import { useMutation } from '@tanstack/react-query';

import { useRequestConstructor } from '../../../../hooks/useRequestConstructor';
import { postRequestConfirmationCode } from '../../requests/postRequestConfirmationCode';

export const useRequestConfirmationCode = () => {
  const { constructPost } = useRequestConstructor();
  const { mutateAsync, ...rest } = useMutation({
    mutationFn: (data: Record<string, unknown>) =>
      postRequestConfirmationCode(constructPost, data),
  });
  return { requestConfirmationCode: mutateAsync, ...rest };
};
